var filter = require('./removeSubText.js');

module.exports = function tagText(text, tags) {
	
	var currPos = 0;
	var terms = [];

	const addTerm = (text, anchor, entities) => {

		if (text.length <= 0) return;
		
		if(anchor === undefined){
			terms.push({
			text,
			anchor: {
				start: undefined,
				stop: undefined
			},
			entities: entities || [],
		});
		}else{
			terms.push({
			text,
			anchor,
			entities: entities || [],
		});
		}
	}


	tags.forEach((tag) => {

		addTerm(text.slice(currPos, tag.anchor.start));
		addTerm(text.slice(tag.anchor.start, tag.anchor.stop), tag.anchor, tag.entities);
		currPos = tag.anchor.stop;
	});

	addTerm(text.slice(currPos));
	
	
	var filteredTerms = filter(terms);
	
	return filteredTerms;
};






